// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__exqP_","text":"Button_text__bvVGC","loader":"Button_loader__FZv13","icon":"Button_icon__r3wfm"};